import { SvgIcon, type SvgIconProps } from './svgIcon'

type Props = SvgIconProps & {
  width?: number
  height?: number
  fontSize?: number
  primaryColor?: string
  secondaryColor?: string
  strokeWidth?: number
}

export function FeeImmunityIcon({ width = 24, height = 24, ...props }: Props) {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      {...props}>
      <path
        d="M18.0859 14.6793L20.9999 11.7653L20.3085 11.074C20.0303 10.7957 19.5843 10.7798 19.287 11.0375L16.6926 13.286L15.6292 12.2226L18.3046 9.90401C19.1966 9.1309 20.5345 9.17862 21.3692 10.0133L23.1212 11.7653L19.1466 15.74L18.0859 14.6793Z"
        fill="currentColor"
      />
      <path
        d="M10.7766 7.36995C11.8021 6.82337 12.5001 5.7432 12.5001 4.5C12.5001 2.70507 11.045 1.25 9.25011 1.25C8.00691 1.25 6.92674 1.94803 6.38016 2.97355L7.53883 4.13221C7.70778 3.34231 8.40977 2.75 9.25011 2.75C10.2166 2.75 11.0001 3.5335 11.0001 4.5C11.0001 5.34034 10.4078 6.04234 9.6179 6.21129L10.7766 7.36995Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2501 4.25C16.4928 4.25 17.5001 5.25736 17.5001 6.5C17.5001 7.74264 16.4928 8.75 15.2501 8.75C14.0075 8.75 13.0001 7.74264 13.0001 6.5C13.0001 5.25736 14.0075 4.25 15.2501 4.25ZM16.0001 6.5C16.0001 6.08579 15.6643 5.75 15.2501 5.75C14.8359 5.75 14.5001 6.08579 14.5001 6.5C14.5001 6.91421 14.8359 7.25 15.2501 7.25C15.6643 7.25 16.0001 6.91421 16.0001 6.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.53033 1.46967L1.46967 2.53033L9.48957 10.5502H8.27473L4.63456 13.9763L3.92113 13.2628L1 16.184L7.87461 23.0586L10.7957 20.1375L10.098 19.4397L11.2084 18.3293H14.5897C15.3432 18.3293 16.0783 18.1503 16.738 17.8157L16.7465 17.8072L21.4697 22.5303L22.5303 21.4697L2.53033 1.46967ZM14.5897 16.8293C14.9336 16.8293 15.2718 16.7748 15.5929 16.6706L15.6044 16.6651L13.7803 14.8409H10.1477V13.3409H12.2803L10.9896 12.0502H8.86959L5.69571 15.0374L9.03733 18.379L10.2942 17.1222C10.4817 16.9347 10.7361 16.8293 11.0013 16.8293H14.5897ZM4.6029 16.0659L4.58654 16.0813L4.07842 15.5414L3.92113 15.3842L3.12132 16.184L7.87461 20.9373L8.67436 20.1375L4.6029 16.0659Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
